import Cookies from "js-cookie";

export default function UserLogout() {
  Cookies.remove("token");
}
